var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 6.37307C2.25 4.07558 4.16114 2.25 6.47246 2.25H17.5842C19.8642 2.25 21.75 4.05092 21.75 6.318C21.75 7.52281 21.2037 8.66027 20.2668 9.43032L16.7465 12.3238C15.7936 13.107 15.25 14.2522 15.25 15.4521V17.1817C15.25 18.2855 14.7061 19.3147 13.8002 19.9547L11.859 21.3261C10.3855 22.367 8.25 21.3745 8.25 19.5134V15.336C8.25 14.1925 7.75613 13.0961 6.87987 12.3159L3.62728 9.41967C2.75289 8.64108 2.25 7.53648 2.25 6.37307ZM8 6.25C7.58579 6.25 7.25 6.58579 7.25 7C7.25 7.41421 7.58579 7.75 8 7.75L16 7.75C16.4142 7.75 16.75 7.41422 16.75 7C16.75 6.58579 16.4142 6.25 16 6.25L8 6.25Z",
    fill: "#8214DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b9a5a4b8ee605464a6324bc28880a195.svg";
export { ForwardRef as ReactComponent };